import { useState } from 'react';

import { Spinner } from '@blueprintjs/core';
import { datadogRum } from '@datadog/browser-rum';
import {
  CheckRounded as CheckRoundedIcon,
  ClearRounded as ClearRoundedIcon,
} from '@material-ui/icons';
import { useIndxResults } from '@opendoor/tessellation';
import moment from 'moment';

import useAcceptWorkOrder from '../../../graphql/mutations/homework/useAcceptWorkOrder';
import useRejectWorkOrder from '../../../graphql/mutations/homework/useRejectWorkOrder';
import useReIndexWorkOrder from '../../../graphql/mutations/indextrious/useReIndexWorkOrder';
import RejectDialog from './RejectionReasonDialog';

interface AcceptRejectProps {
  workOrderID: string;
}

const AcceptReject = (props: AcceptRejectProps) => {
  const [acceptWorkOrder] = useAcceptWorkOrder();
  const [rejectWorkOrder] = useRejectWorkOrder();
  const { refetch } = useIndxResults();

  const [reIndexWorkOrder] = useReIndexWorkOrder();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    setLoading(true);

    const startTimestamp = moment();

    const { errors } = await acceptWorkOrder({
      variables: { workOrderID: props.workOrderID },
    });

    if (!errors) {
      await reIndexWorkOrder({ variables: { id: props.workOrderID } });
      refetch();
    }

    datadogRum.addAction('acceptWorkOrder', {
      id: props.workOrderID,
      timeTakenInMs: moment().diff(startTimestamp, 'milliseconds'),
    });
    setLoading(false);
  };

  const handleReject = async (reason: string) => {
    setDialogOpen(false);
    setLoading(true);

    const startTimestamp = moment();

    try {
      const { errors } = await rejectWorkOrder({
        variables: { workOrderID: props.workOrderID, reason },
      });

      if (!errors) {
        await reIndexWorkOrder({ variables: { id: props.workOrderID } });
        refetch();
      }
    } catch (e: any) {
      alert(e.message);
    }

    datadogRum.addAction('rejectWorkOrder', {
      id: props.workOrderID,
      timeTakenInMs: moment().diff(startTimestamp, 'milliseconds'),
    });
    setLoading(false);
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="flex">
      {dialogOpen && (
        <RejectDialog
          isOpen={dialogOpen}
          onCancel={() => setDialogOpen(false)}
          onConfirm={handleReject}
        />
      )}
      <button
        style={{ cursor: 'pointer' }}
        onClick={handleAccept}
        className="ma-1 pa-3 boa-1 bo-radius-2 bo-color-black hover-bg-gray1"
      >
        <div style={{ height: 24, width: 24 }}>
          <CheckRoundedIcon />
        </div>
      </button>
      <button
        style={{ cursor: 'pointer' }}
        className="ma-1 pa-3 boa-1 bo-radius-2 bo-color-black hover-bg-gray1"
        onClick={() => setDialogOpen(true)}
      >
        <div style={{ height: 24, width: 24 }}>
          <ClearRoundedIcon />
        </div>
      </button>
    </div>
  );
};

export default AcceptReject;
